import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://ams-prod.matchandmake.de/api",
});

export default apiClient;
